import { Component, Injector, ViewChild, OnInit, Input, TemplateRef, AfterViewInit } from '@angular/core';
import { NgForm, UntypedFormArray, UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators, AbstractControl, ValidatorFn } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BaseEntityComponent, BnLoadingService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService, Usuario } from "@bndes/bndes-ux4/bn-usuario";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import moment from "moment";
import { Observable, of } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { CanComponentDeactivate } from 'src/app/core/can-deactivate-guard.service';
import { AgenteFinanceiro } from 'src/app/model/agente-financeiro.model';
import { Aviso, TIPOS_AVISO, TIPO_SEVERIDADE } from 'src/app/model/aviso.model';
import { OcorrenciaValidacaoVO } from 'src/app/shared/ocorrencia-validacao.vo';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { QuestionarioService } from '../questionario.service';
import { PerguntaEnergiaDTO, TipoPerguntaEnum, QuestionarioRespostaEnergiaDTO, OpcaoQuestionarioRespostaEnergiaDTO, TipoValorPerguntaEnum, TamanhoPerguntaEnum, TipoCustomizacaoEnum, ResponsavelAvaliacaoEconomiaDTO } from '../../model/questionario.model';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'app-questionario-recomendacoes-ao-cliente',
    templateUrl: './questionario-recomendacoes-ao-cliente.component.html',
    styleUrls: ['./questionario-recomendacoes-ao-cliente.component.scss'],
    standalone: false
})
export class QuestionarioRecomendacoesAoClienteComponent implements OnInit {
    public formGroup: UntypedFormGroup;
    
    public respostas: UntypedFormArray = new UntypedFormArray([]);

    private static readonly TIPO_INPUT_RADIO :string = 'radio';
    private static readonly TIPO_INPUT_CHECKBOX :string = 'checkbox';
    private static readonly TIPO_INPUT_TEXT :string = 'text';
    private static readonly TIPO_INPUT_CUSTOM :string = 'custom';
    private static readonly TIPO_INPUT_DATE :string = 'date';
    
    constructor(
        private modalService: BnModalMessageService,
        protected injector: Injector,
        private loadingService: BnLoadingService,
        private removerAlertasService: RemoverAlertasService,
        private alertsService: BnAlertsService,
        private formBuilder: UntypedFormBuilder,
        private sanitizer: DomSanitizer) {

    }
    
    ngOnInit() {
        this.formGroup = this.formBuilder.group({
            termoRelatorio: [false, Validators.requiredTrue],
            termoPaineis: [false, Validators.requiredTrue],
            termoViabilidade: [false, Validators.requiredTrue],
            termoFaturamento: [false, Validators.requiredTrue],
            termoRecomendacoes: [false, Validators.requiredTrue],
            termoFalsidade: [false, Validators.requiredTrue]
        });
    }

    public get respostasQuestionario(): UntypedFormArray { 
        return this.formGroup.get('respostas') as UntypedFormArray; 
    }

    public retornaRespostasPreenchidas(): QuestionarioRespostaEnergiaDTO[] {
        return [];
    }
}
